import { downgradeInjectable } from '@angular/upgrade/static';
import { ClusterService } from '@fry-it/risr-core';

(function() {
  'use strict';

  angular.module('component.organisations')
    .factory('ClusterService', downgradeInjectable(ClusterService));
})();
